/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ACSStrictHttpResponse } from '../../acs-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnonyUserTokenModel } from '../../models/anony-user-token-model';
import { VoipUserModel } from '../../models/voip-user-model';

export interface VoipGetAnonymousUserPost$Params {
      body?: AnonyUserTokenModel
}

export function voipGetAnonymousUserPost(http: HttpClient, rootUrl: string, params?: VoipGetAnonymousUserPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<VoipUserModel>> {
  const rb = new RequestBuilder(rootUrl, voipGetAnonymousUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ACSStrictHttpResponse<VoipUserModel>;
    })
  );
}

voipGetAnonymousUserPost.PATH = '/Voip/GetAnonymousUser';
